import React, { useEffect, useState } from "react";
import { Wheat } from "lucide-react";
import { formatIDR, formatPct, titleCase } from "../lib/format";

const RiskBadge = ({ score }) => {
  let label = "Aman";
  let color = "#10b981";
  if (score >= 70) { label = "Kritis"; color = "#ef4444"; }
  else if (score >= 50) { label = "Waspada"; color = "#f59e0b"; }
  else if (score >= 30) { label = "Siaga"; color = "#facc15"; }
  return (
    <span className="hp-status-pill" style={{ borderColor: color, color }}>
      Status Komoditas : <strong>{label}</strong>
    </span>
  );
};

export const HargaPangan = ({ commodities = [] }) => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (commodities.length === 0) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % commodities.length), 5500);
    return () => clearInterval(t);
  }, [commodities.length]);

  const c = commodities[idx];

  return (
    <div className="nms-card bottom-card harga-pangan" data-testid="harga-pangan-card">
      <div className="bc-head">
        <h3 className="bc-title">
          <Wheat size={14} /> HARGA PANGAN NASIONAL
        </h3>
        <span className="bc-live">● LIVE</span>
      </div>

      {c && (
        <div className="hp-body" data-testid="harga-pangan-body">
          <RiskBadge score={c.riskScore || 0} />

          <div className="hp-main">
            <div className="hp-icon">
              <svg viewBox="0 0 48 48" width="48" height="48">
                <defs>
                  <linearGradient id="hp-grad" x1="0" y1="0" x2="48" y2="48">
                    <stop offset="0%" stopColor="#fbbf24" />
                    <stop offset="100%" stopColor="#f59e0b" />
                  </linearGradient>
                </defs>
                <rect
                  x="6"
                  y="6"
                  width="36"
                  height="36"
                  rx="10"
                  fill="url(#hp-grad)"
                  fillOpacity="0.18"
                  stroke="#f59e0b"
                  strokeOpacity="0.6"
                />
                <path
                  d="M16 30 Q18 20 24 18 Q30 20 32 30"
                  stroke="#fbbf24"
                  strokeWidth="2"
                  fill="none"
                />
                <circle cx="24" cy="14" r="2.5" fill="#fbbf24" />
              </svg>
            </div>
            <div className="hp-text">
              <div className="hp-name">{titleCase(c.name).toUpperCase()}</div>
              <div className="hp-price-row">
                <span className="hp-curr">Rp</span>
                <span className="hp-price">{formatIDR(c.price)}</span>
                <span
                  className={`hp-change ${(c.changePct || 0) > 0 ? "up" : (c.changePct || 0) < 0 ? "down" : "flat"}`}
                >
                  {formatPct(c.changePct || 0)}
                </span>
              </div>
              <div className="hp-sub">Harga hari ini · /{c.unit}</div>
            </div>
          </div>

          <div className="hp-dots">
            {commodities.map((_, i) => (
              <span key={i} className={`hp-dot ${i === idx ? "active" : ""}`} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default HargaPangan;
